<template>
  <v-select v-model="localLang" dense flat  :items="languages" @change="onLangChange"
            :aria-label="$t('generic.langSelect')" color="main_pink"
  />
</template>

<script>
import { i18n, setLang } from "src/locales";

export default {
  name: "lang-select",
  props: { value: {} },
  components: {},
  data() {
    return {
      localLang: i18n.locale, // Default to English
      languages: [
        { text: "עברית", flag: "flag-icon-il", value: "he", url: "?lang=he" },
        { text: "English", flag: "flag-icon-us", value: "en", url: "?lang=en" },
        { text: "العربية", flag: "flag-icon-ps", value: "ar", url: "?lang=ar" }
      ],

    };
  },

  methods: {
    onLangChange() {
      setLang(this.localLang);
    },
  }
};
</script>

<style scoped>

</style>
